@use "variables" as *;

.oldPrice {
  font-size: $fontSize-xs;
  text-decoration-line: line-through;
  font-weight: lighter;
}

.newPrice {
  font-size: $fontSize-m;
  font-weight: bold;
}
